function Footer() {
  return (
    <footer className="dark-footer">
      <div>
        <div className="container">
          <div className="row">
						<div className="col-12 px-8">
              <div className="footer-widget text-center">
								<h4 className="widget-title mb-2 px-2">Instituto Universitario de Tecnología de Administración Industrial (IUTA) - Extensión Maturín</h4>

								<a className="footer-link" target="_blank" rel="noreferrer"
									href="https://maps.app.goo.gl/oQRs7vFCK3HyiHkY6">
									<div className="my-3">
										<i className="bi bi-geo pe-2" style={{ color: "var(--redcolor)" }}></i>
										Edificio IUTA, Calle Barreto, con Av. Miranda, Maturín 6201, Monagas
									</div>
								</a>

								<a className="align-items-center footer-link gap-2"
									href="tel:+584228480364" target="_blank" rel="noreferrer">
									<div className="d-flex justify-content-center my-3">
										<div className="square--30 circle bg-light-main text-main">
											<i className="bi bi-telephone"></i>
										</div>
										<div className="fs-6 fw-semibold">+58 422-8480364</div>
									</div>
								</a>

								<a className="align-items-center footer-link gap-2"
									href="https://wa.me/584228480364" target="_blank" rel="noreferrer">
									<div className="d-flex justify-content-center my-3">
										<div className="square--30 circle bg-light-main text-main">
											<i className="bi bi-whatsapp"></i>
										</div>
										<div className="fs-6 fw-semibold">+58 422-8480364</div>
									</div>
								</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-8">
              <p className="mb-0">© 2026  IUTA Maturín</p>
            </div>

            <div className="col-4 text-end">
							<ul className="footer-bottom-social">
								<li>
									<a href="https://www.instagram.com/iutamaturin/" target="_blank" rel="noreferrer">
										<i className="ti-instagram"></i>
									</a>
								</li>
								<li>
									<a href="mailto:contacto@iutamaturin.edu.ve" target="_blank" rel="noreferrer">
										<i className="ti-email"></i>
									</a>
								</li>
							</ul>
						</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
